import { render, staticRenderFns } from "./GenericDataTable.vue?vue&type=template&id=727be9b6&scoped=true&"
import script from "./GenericDataTable.vue?vue&type=script&lang=js&"
export * from "./GenericDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GenericDataTable.vue?vue&type=style&index=0&id=727be9b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727be9b6",
  null
  
)

export default component.exports